import _ from 'lodash';
import { goto, preload } from 'react-isomorphic-render';
import { connect } from 'react-redux';
import { contentfulModels } from '@glowforge/ui-common';
import * as api from 'app/api/account-settings-api';
import { nameMachine, fetchGlowforgeNamePage } from 'app/api/onboarding-api';
import MachineName from 'app/components/setup/machine-name';
import features from 'app/common/containers/features';
import { COLOR_MODES } from 'app/app-constants';
import { setSelectedMode } from 'app/actions/onboarding';

const { getStringsForPage } = contentfulModels;

const mapStateToProps = (state, route) => {
  const pageStrings = getStringsForPage(_.get(state, 'onboarding.glowforgeNamePage'));
  const isOrangeMode = _.get(route, 'location.query.mode') === COLOR_MODES.ORANGE;

  return ({
    initialValues: {
      name: pageStrings['onboarding-name-placeholder'],
    },
    pageStrings,
    title: _.get(state, 'onboarding.glowforgeNamePage.title'),
    isOrangeMode,
  });
};

const mapDispatchToProps = (dispatch, props) => ({
  onSubmit: (values) => {
    let invites = Promise.resolve();
    const defaultRoles = props.features.USER_ROLE_MANAGEMENT ? [] : ['manager'];
    if (values.email && values.email.length > 0) {
      invites = dispatch(api.sendInvites({
        email: values.email,
        machines: [{
          serial: props.params.serial,
          machineName: values.name,
          roles: defaultRoles,
        }],
      }));
    }
    return Promise.all([
      invites,
      dispatch(nameMachine(props.params.serial, values.name)),
    ])
      .then(() => {
        dispatch(goto('/setup/finished'));
      });
  },
});

const PreloadedMachinePage = preload(
  ({ dispatch, location }) => {
    const promises = [dispatch(fetchGlowforgeNamePage())];
    const searchParams = new URLSearchParams(location.search);
    const mode = searchParams.get('mode');
    if (mode) {
      promises.push(dispatch(setSelectedMode(mode)));
    }
    return Promise.all(promises);
  },
)(MachineName);

const MachineNameContainer = connect(mapStateToProps, mapDispatchToProps)(PreloadedMachinePage);

export default features(MachineNameContainer);



// WEBPACK FOOTER //
// ./app/containers/setup/machine-name.js